import LogRocket from 'logrocket';

import { isProduction } from './is-production';

export function initLogRocket() {
  try {
    if (isProduction()) {
      type LogRocketOptions = Parameters<typeof LogRocket.init>[1];

      const config: LogRocketOptions = {
        network: {
          requestSanitizer: (request) => {
            const url = request.url.toLowerCase();

            if (url.includes('/posv3/user/employeelogin')) {
              request.body = undefined;
            }

            if (url.includes('/posv3/user/resetpassword')) {
              request.body = undefined;
            }

            return request;
          },
        },
      };

      LogRocket.init('zg2tcu/leaflogix-boh', config);
    }
  } catch (error) {
    console.error('Failed to initialize LogRocket', error);
  }
}
